import React from 'react';
import Headline from '../../atoms/Headline';
import { beautifyPrice } from '../../../utils';

class OptionsSponsoring extends React.Component {
    
    render () {
        return (
          <div className="optionssponsoring">
            <div className="header">
              <Headline typeOf="h3">Förderbetrag</Headline>
            </div>
            <div className="inner">
                <div className="help">
                  <h6>Dieses Paket wird mit <span dangerouslySetInnerHTML={{__html:beautifyPrice(this.props.sponsoring.supportPrice)}} /> € gefördert</h6>
                </div>
            </div>
          </div>
        );
    }

}


export default OptionsSponsoring;






// WEBPACK FOOTER //
// ./src/components/molecules/OptionsSponsoring/OptionsSponsoring.js